import React, { SVGProps } from 'react'
const SvgAlertCircleFilledUpdated = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#D5404A"
      fillRule="evenodd"
      d="M5 .125a4.875 4.875 0 1 1 0 9.75 4.875 4.875 0 0 1 0-9.75ZM5 2.13c.188 0 .344.139.37.32l.005.055v3.587a.375.375 0 0 1-.746.056l-.004-.056V2.505c0-.207.168-.375.375-.375Zm.37 5.316a.375.375 0 0 0-.745.055v.212l.004.055a.375.375 0 0 0 .746-.055V7.5l-.004-.055Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgAlertCircleFilledUpdated
